<script>
  import SettingListAdd from "../Components/TriggerActions/SettingListAdd.svelte";
  import SettingEmailOpen from "../Components/TriggerActions/SettingEmailOpen.svelte";
  import SettingEmailClick from "../Components/TriggerActions/SettingEmailClick.svelte";
  import SettingPageVisit from "../Components/TriggerActions/SettingPageVisit.svelte";
  import SettingTagAdd from "../Components/TriggerActions/SettingTagAdd.svelte";
  import SettingPropertyChange from "../Components/TriggerActions/SettingPropertyChange.svelte";
  import SettingPurchaseMake from "../Components/TriggerActions/SettingPurchaseMake.svelte";
  import SettingCheckCartAbandon from "../Components/TriggerActions/SettingCheckCartAbandon.svelte";
  import {ignore} from "../../Common/tools";
  import SettingMemberGroupAdd from "../Components/TriggerActions/SettingMemberGroupAdd.svelte";
  import SettingMemberGroupRemove from "../Components/TriggerActions/SettingMemberGroupRemove.svelte";
  import SettingSelectVideo from '../Components/TriggerActions/SettingSelectVideo.svelte';
  import { M } from '../../external';

  export let data,
    onChange = ignore;

  let valid = true;

  export function get() {
    return data;
  }

  export function isValid() {
    return valid;
  }
</script>

<div class="col20 f-left small-rules mb-25">
  {#if data.type === "LIST_ADD"}
    <SettingListAdd bind:data bind:valid onChange={onChange} />
    <!--{:else if data.type === "LIST_REMOVE"}-->
    <!--    <SettingListRemove bind:data={data} bind:valid={valid} {onChange} />-->
  {:else if data.type === "MEMBER_GROUP_ADD"}
    <SettingMemberGroupAdd bind:data bind:valid onChange={onChange} />
  {:else if data.type === "MEMBER_GROUP_REMOVE"}
    <SettingMemberGroupRemove bind:data={data} bind:valid={valid} {onChange} />
  {:else if data.type === "EMAIL_OPEN"}
    <SettingEmailOpen bind:data bind:valid onChange={onChange} />
  {:else if data.type === "EMAIL_CLICK"}
    <SettingEmailClick bind:data bind:valid onChange={onChange} />
  {:else if data.type == "PAGE_VISIT"}
    <SettingPageVisit bind:data bind:valid onChange={onChange} />
  {:else if data.type == "TAG_ADD"}
    <SettingTagAdd bind:data bind:valid onChange={onChange} />
    <!--    {:else if data.type == "TAG_REMOVE"}
    <SettingTagRemove bind:data bind:valid {onChange} />-->
  {:else if data.type == "PROPERTY_CHANGE"}
    <SettingPropertyChange bind:data bind:valid onChange={onChange} />
  {:else if data.type == "PURCHASE_MAKE"}
    <SettingPurchaseMake bind:data bind:valid onChange={onChange} />
  {:else if data.type == "CART_ABANDON"}
    <SettingCheckCartAbandon bind:data bind:valid onChange={onChange} />
  {:else if data.type == "VIDEO_STARTED"}
    <SettingSelectVideo bind:data bind:valid onChange={onChange} label={M.VIDEO_STARTED_AUTOMATION_DEFINITION} />
  {:else if data.type == "VIDEO_COMPLETED"}
    <SettingSelectVideo bind:data bind:valid onChange={onChange} label={M.VIDEO_COMPLETED_AUTOMATION_DEFINITION} />
  {:else}{/if}
</div>
